import React from "react";
import { Link } from "react-router-dom";

import Logo from "../imgs/full-logo.svg";

import Email from "../imgs/socials/Tw.svg";
import Tiktok from "../imgs/socials/Ln.svg";
import Ig from "../imgs/socials/In.svg";
import Fb from "../imgs/socials/Fb.svg";

const Footer = () => {
  const currentDate = new Date();

  return (
    <footer className="bg-white py-10 mx-auto max-w-7xl">
      <div className="container mx-auto flex flex-col lg:flex-row items-center lg:justify-between">
        <div className="flex space-x-4 mb-4 lg:mb-0 order-2 lg:order-1">
          <a href="mailto:info@hallimo.com">
            <img src={Email} height={40} width={40} />
          </a>
          <a href="https://www.tiktok.com/@hallimocentral">
            <img src={Tiktok} height={40} width={40} />
          </a>
          <a href="https://www.instagram.com/hallimocentral">
            <img src={Ig} height={40} width={40} />
          </a>
          <a href="https://www.facebook.com/hallimocentral">
            <img src={Fb} height={40} width={40} />
          </a>
        </div>

        <div className="flex justify-center order-1 pb-8 lg:pb-0 lg:order-2">
          <img src={Logo} alt="Logo" className="h-6 w-auto" />
        </div>

        <div className="space-x-6 mt-4 md:mt-0 order-3">
          <div className="flex flex-row lg:flex-col justify-between lg:items-end pb-5 lg:space-y-2">
            <Link to="/terms-and-conditions" className="text-sm">
              Terms of Service
            </Link>
            <Link to="/privacy-policy" className="text-sm">
              Privacy Policy
            </Link>
          </div>

          <p className="text-center lg:text-end text-sm">
            © {currentDate.getFullYear()} Hallimo Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
